import React from 'react'

const NoPage = () => {
  return (
    <section className='bg-black py-64'>
      <div className='flex justify-center'>
        <h1 className='text-red-400 text-2xl'>No Page Found - 404</h1>
      </div>
    </section>

  )
}

export default NoPage;